import { useEffect, useRef } from 'react';

export default function useTemplateEditorHook({ tagValues, originalValue }) {
  const editor = useRef(null);
  const IMAGE_TAGS = ['chain_logo', 'hotel_logo', 'guest_signature', 'holder_signature'];
  const EDITOR_HEIGHT = 512;
  const JODIT_CODE_MODE = 2;

  useEffect(() => {
    if (!editor.current || originalValue == null) return;

    let text = originalValue;
    for (const { key, value } of tagValues || []) {
      if (value) text = text.replaceAll(`[${key}]`, value);
    }

    editor.current.setEditorValue(text);
  }, [tagValues, originalValue]);

  useEffect(() => {
    if (!editor.current) return;

    const beforeGet = () => {
      let text = originalValue;
      for (const { key, value } of tagValues || []) {
        if (value) text = text.replaceAll(value, `[${key}]`);
      }
      return text;
    };

    editor.current.events.on('beforeGetModeValue', beforeGet);
    return () => {
      editor.current.events.off('beforeGetModeValue', beforeGet);
    };
  }, [tagValues, originalValue]);

  const actions = {
    setEditorRef: ref => {
      editor.current = ref;
    },

    insertTag: tag => {
      if (!tag || !editor.current) return;
      const found = tagValues?.find(item => item.key === tag);
      const content = (!found || !found.value || editor.current.getMode() === JODIT_CODE_MODE)
        ? `[${tag}]`
        : found.value;

      if (IMAGE_TAGS.includes(tag)) {
        editor.current.selection.insertHTML(
          `<img src="${content}" height="100" />`
        );
      } else {
        editor.current.selection.insertHTML(content);
      }
    },

    getEditorConfig: disabled => ({
      height: EDITOR_HEIGHT,
      maxHeight: EDITOR_HEIGHT,
      minHeight: EDITOR_HEIGHT,
      removeButtons: ['fullsize','print','dots','copyformat','image'],
      showCharsCounter: false,
      showWordsCounter: false,
      sourceEditorNativeOptions: { theme: 'white' },
      placeholder: '',
      readonly: disabled,
      cleanHTML: { fillEmptyParagraph: false },
      style: { backgroundColor: 'white' },
      iframe: true,
      toolbarAdaptive: false
    }),
  };

  return { actions };
}
